import * as React from 'react';
import { ArticleHeading0 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { About as AboutComponent } from '../../components/About';
import { FavoriteButton } from '../../components/Favorite/FavoriteButton';
import { Layout } from '../../components/Layout';
import { getName } from '../../selectors/newbuilding';
import { FavoriteContainer } from '../Favorite';
import { NewbuildingBrochureContainer } from '../NewbuildingBrochure';
import { NewbuildingCompareButton } from '../NewbuildingCompareButton';
import { NewbuildingDescriptionContainer } from '../NewbuildingDescription';

export const About = () => {
  const name = useSelector(getName);

  return (
    <Layout>
      <AboutComponent
        title={<ArticleHeading0 as="h2">{`О жилом комплексе «${name}»`}</ArticleHeading0>}
        controls={
          <>
            <FavoriteContainer button={FavoriteButton} buttonTheme="stroke_primary" buttonSize="M" />
            <NewbuildingCompareButton buttonTheme="stroke_primary" source="about_building" />
          </>
        }
        description={<NewbuildingDescriptionContainer />}
        brochure={<NewbuildingBrochureContainer />}
      />
    </Layout>
  );
};

About.displayName = 'About';
